<template>
  <v-card class="elevation-1 pa-3 login-card">
    <v-card-text>
      <div class="layout column align-center">
        <img src="@/assets/logo.png" alt="Prwatech" />
        <h1 class="flex my-4 primary--text">Admin Login</h1>
      </div>
      <v-form @submit.prevent="OnSubmit">
        <v-text-field v-if='!OTP_Sent' append-icon="person" name="User_Name" label="Username" type="text" v-model="User_Name" @keyup.enter="OnSubmit"></v-text-field>
        <v-text-field v-else append-icon="lock" name="OTP" label="OTP" type="password" v-model="OTP" @keyup.enter="OnSubmit"></v-text-field>
        <div class="login-btn">
          <v-btn block color="primary" type="submit" v-if="!OTP_Sent" :loading="loading">Login</v-btn>
          <v-btn block color="primary" type="submit" v-else :loading="loading">Verify OTP</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    loading    : false,
    User_Name  : "",
    OTP_Sent   : false,
    OTP        : '',
    Email      : ""
  }),

  methods: {
    OnSubmit() {
      if (this.loading) return
      this.OTP_Sent ? this.Verify() : this.Login()
    },
    Login() {

      this.loading = true
      this.$http.post(`${this.$store.getters.GetProductionUrl}/login/admin`,{ 'User_Name' : this.User_Name })
                    .then(response =>{
                
                      if(response['data']['success'] == true){
                          
                          this.Email    = response['data']['info']['Email']
                          this.OTP_Sent = true
                          this.loading  = false
                      
                      }else{
                          this.loading = false
                          this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Logging In","Color":"red","Close": false });
                      }
                    })
                    .catch(err =>{
                        this.loading = false
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
      
    },
    Verify(){

      this.loading = true
      this.$http.post(`${this.$store.getters.GetProductionUrl}/login/verifyotp`,{ 'Email' : this.Email , OTP : parseInt(this.OTP)})
                    .then(response =>{
                      console.log(response)
                      if(response['data']['success'] == true){
                        
                        this.loading  = false
                        var d = new Date()
                        d.setTime(d.getTime() + (7*24*60*60*1000));
                        document.cookie = `access_token=${response.data.token};expires=${d.toUTCString()}`
                        this.$http.defaults.headers.common['Authorization'] = response.data.token
                        this.$store.commit('SetTabs',response['data']['info']['Access_Tabs'])
                        this.$router.go()
                      
                      }else{
                          this.loading = false
                          this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Logging In","Color":"red","Close": false });
                      }
                    })
                    .catch(err =>{
                        this.loading = false
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
  },
  mounted(){
    this.$eventHub.$emit("LOADING",'false')
  }
}
</script>
<style scoped lang="css"></style>
